import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from '@app/providers/ErrorBoundary';
import { I18nProvider } from '@app/providers/I18nProvider';
import { QueryProvider } from '@app/providers/QueryProvider';
import { ThemeProvider } from '@app/providers/ThemeProvider';
import { ToastProvider } from '@app/providers/ToastProvider';
import { AppRoutes } from '@app/router/routes';

export function App() {
  return (
    <ErrorBoundary>
      <I18nProvider>
        <ThemeProvider>
          <QueryProvider>
            <BrowserRouter>
              <AppRoutes />
              <ToastProvider />
            </BrowserRouter>
          </QueryProvider>
        </ThemeProvider>
      </I18nProvider>
    </ErrorBoundary>
  );
}
